const postRoutes = {
  path: 'posts',
  name: 'postsOverview',
  components: {
    default: () => import('@/views/PageRoutView')
  },
  redirect: { name: 'posts' },
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '/:channelId/posts',
      name: 'posts-list',
      component: () => import('@/views/Posts/PostsList'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:channelId/posts/publish',
      name: 'publish-list',
      component: () => import('@/views/Posts/PublishList'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:channelId/posts/:key/edit',
      name: 'posts-edit',
      component: () => import('@/views/Posts/PostEdit'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:channelId/posts/requests',
      name: 'request-list',
      component: () => import('@/views/Posts/PostPublishRequest'),
      meta: {
        requiresAuth: true
      }
    },
  ]
}

export default postRoutes
